import { createSlice } from "@reduxjs/toolkit";
import { fetchFieldStock } from "./thunk";

interface MyTeamState {
  List: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: MyTeamState = {
  List: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const FieldStockSlice = createSlice({
  name: "InStock",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFieldStock.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFieldStock.fulfilled, (state, action) => {
        state.loading = false;
        state.List = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchFieldStock.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message ||
          "Failed to fetch Field Engineer Field Stock";
      });
  },
});

export default FieldStockSlice.reducer;
